<div class="breadcrumbs overlay">
    <div class="container">
        <div class="bread-inner">
            <div class="row">
                <div class="col-12">
                    <h2>Métiers</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<br>


<section class="why-choose section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title">
                </div>
            </div>
        </div><br>
        <div class="row">

            <div class="row mt-4">
              <div class="col-md-6">
                  <div class="card card-custom h-100">
                      <div class="card-body">
                        <h4 class="card-title" style="color: #415cc0;">CONTRÔLE DES COMPTES</h4>
                        <ul>
                            <li>Vérification des comptes des ministères et services de l'État</li>
                            <li>Examen des comptes des établissements publics</li>
                            <li>Contrôle de la régularité des opérations financières</li>
                            <li>Certification des comptes rendus financiers</li>
                            <li>Rapports d'observations définitives</li>
                        </ul>
                      </div>
                  </div>
              </div>
              <div class="col-md-6">
                  <div class="card card-custom h-100">
                      <div class="card-body">
                        <h4 class="card-title" style="color: #415cc0;">AUDIT FINANCIER</h4>
                        <ul>
                            <li>Audit des entreprises du portefeuille de l'État</li>
                            <li>Audit des collectivités territoriales</li>
                            <li>Audit de gestion des organismes publics</li>
                            <li>Audits spécifiques sur demande du Parlement</li>
                        </ul>
                      </div>
                  </div>
              </div>
          </div>


            <!-- Deuxième ligne : Deux cartes côte à côte -->
            <div class="row mt-4">
                <div class="col-md-6">
                    <div class="card card-custom h-100">
                        <div class="card-body">
                            <h4 class="card-title" style="color: #415cc0;">RAPPORTS ET PUBLICATIONS</h4>
                            <ul>
                                <li>Rapports annuels d'activités</li>
                                <li>Rapports spéciaux d'information</li>
                                <li>Rapports sur les comptes de l'État</li>
                                <li>Travaux thématiques sur la gestion publique</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card card-custom h-100">
                        <div class="card-body">
                            <h4 class="card-title" style="color: #415cc0;">SOUTIEN À LA GOUVERNANCE</h4>
                            <ul>
                                <li>Appui technique aux organismes de contrôle interne</li>
                                <li>Formation en audit public et contrôle financier</li>
                                <li>Collaboration avec les institutions régionales et internationales</li>
                                <li>Promotion de la transparence dans la gestion publique</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bouton en dessous -->
            <div class="text-center mt-3">
                <a (click)="goToMission()" href="javascript:void(0);" class="btn btn-primary text-white" style="padding: 8px; font-size: 15px;">Réalisations</a>
            </div>



        </div>
    </div>

</section>
<br>
